// Sourcing Change Data Reducer

import DefaultData from '../Components/DefaultSourceData';


//Default to test data
const dataReducerDefaultState = {
    payload : DefaultData
};

export default (state = dataReducerDefaultState, action) => {
    switch(action.type) {
        case 'LOAD_DATA':
            return {
                ...state,
                payload : action.payload.length === 0 ? dataReducerDefaultState.payload : action.payload
            };
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/Reducers/data.js